import emitter from './event-bus';
import {homeHeadlinesAnimation} from './home-headlines';

class PageLoad extends HTMLElement {
    constructor() {
        super();

        // load if there is no loader animation first
        if (this.getAttribute('load') === 'true') {
            setTimeout(() => emitter.emit('page-loaded'), 250);
        }
    }

    connectedCallback() {
        emitter.on('page-loaded', () => {
            document.documentElement.style.overflow = 'auto';
            // Set footer style directly here
            const footer = document.querySelector('.site-footer');
            if (footer) {
                // Expand footer if there's a viewport gap (on home page only)
                const expandFooterToFillViewport = () => {
                    if (!document.body.classList.contains('page-homepage')) return;

                    const footer = document.querySelector('.site-footer');
                    if (!footer) return;

                    // Reset height before recalculating
                    footer.style.minHeight = 'auto';

                    const gap = window.innerHeight - (footer.offsetTop + footer.offsetHeight);

                    if (gap > 0) {
                        const newMinHeight = footer.offsetHeight + gap;
                        footer.style.minHeight = `${newMinHeight}px`;
                    }
                };


                expandFooterToFillViewport();
                window.addEventListener('resize', expandFooterToFillViewport);


                const applyHomeLogoAsBackgroundOnMobile = () => {
                    if (!document.body.classList.contains('page-homepage')) return;

                    const isMobile = window.innerWidth <= 500;
                    const left = document.querySelector('.page-content');
                    const rightImg = document.querySelector('#home-logo img');

                    if (!left) return;

                    if (isMobile && rightImg) {
                        left.style.backgroundImage = `url('${rightImg.src}')`;
                        left.style.backgroundSize = 'contain';
                        left.style.backgroundRepeat = 'no-repeat';
                        left.style.backgroundPosition = 'center top 240px';
                    } else {
                        // ✅ Clear background if not mobile
                        left.style.backgroundImage = 'none';
                    }
                };

                applyHomeLogoAsBackgroundOnMobile();
                window.addEventListener('resize', applyHomeLogoAsBackgroundOnMobile);


                footer.style.opacity = '1';
            }

            gsap.to('.page-fade-in', {
                opacity: 1,
                duration: 1,
            });

            homeHeadlinesAnimation(); // 👈 Add your animation call here

            if (window.innerWidth <= 500) {
                window.scrollTo({top: 0, behavior: 'instant'}); // or 'smooth' if you prefer
            }

            // Add toggle button functionality for People page (on mobile)
            if (document.body.classList.contains('page-People') || document.body.classList.contains('page-people') ) {
                this.addPeoplePageToggle();
            }

            this.configureExtLinkPop();
        });
    }

    configureExtLinkPop() {
        const modal = document.getElementById('leave-site-modal');
        const confirmBtn = document.getElementById('leave-confirm');
        const cancelBtn = document.getElementById('leave-cancel');
        let pendingLink = null;

        document.querySelectorAll('a[data-leave-site]').forEach((link) => {
            link.addEventListener('click', function(e) {
                const href = this.href;
                const isExternal = new URL(href).hostname !== location.hostname;

                if (isExternal) {
                    e.preventDefault();
                    pendingLink = href;
                    modal.classList.add('show');
                }
            });
        });

        confirmBtn.addEventListener('click', () => {
            if (pendingLink) {
                window.open(pendingLink, '_blank');
                modal.classList.remove('show');
                pendingLink = null;
            }
        });

        cancelBtn.addEventListener('click', () => {
            modal.classList.remove('show');
            pendingLink = null;
        });


        /*
                document.querySelectorAll('a[data-leave-site]').forEach((link) => {
                    link.addEventListener('click', function(e) {
                        const confirmed = window.confirm('You are now leaving the Eldridge site.\nDo you want to continue?');
                        if (!confirmed) {
                            e.preventDefault();
                        }
                    });
                });
                */
    }

    addPeoplePageToggle() {
        const sectionAnchors = document.querySelectorAll('section-anchor');

        if (sectionAnchors.length >= 4) {
            const targetSections = Array.from(sectionAnchors).slice(2, -1);

            targetSections.forEach((sectionAnchor) => {
                const section = sectionAnchor.querySelector('section');
                if (!section) return;

                const colList = section.querySelector('.col-list');
                const headline = section.querySelector('.headline');
                if (!colList || !headline) return;

                // Store original display value and hide the list
                colList.dataset.originalDisplay = getComputedStyle(colList).display;
                colList.style.display = 'none';

                // Create the toggle button
                const toggleButton = document.createElement('button');
                toggleButton.classList.add('mobile-toggle');

                const chevron = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
                chevron.classList.add('chevron');
                chevron.setAttribute('viewBox', '0 0 24 24');
                chevron.innerHTML = '<path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2" fill="none"></path>';
                toggleButton.appendChild(chevron);

                // Insert toggle button after .headline
                headline.insertAdjacentElement('afterend', toggleButton);

                // Style the button (adjust as needed)
                toggleButton.style.position = 'relative';
                toggleButton.style.left = '-22px';
                toggleButton.style.textAlign = 'left';
                toggleButton.style.marginBottom = '0px';
                toggleButton.style.marginTop = '0px';
                toggleButton.style.paddingBottom = '0px';
                toggleButton.style.paddingTop = '0px';


                // Add toggle functionality
                toggleButton.addEventListener('click', () => {
                    const isHidden = colList.style.display === 'none';
                    colList.style.display = isHidden ? (colList.dataset.originalDisplay || 'grid') : 'none';
                    chevron.style.transform = isHidden ? 'rotate(0deg)' : 'rotate(-90deg)';
                });

                // Handle responsive behavior
                let lastIsMobile = null;

                const handleResize = () => {
                    const isMobile = window.innerWidth <= 600;

                    // Only act on actual mobile/desktop transitions
                    if (isMobile === lastIsMobile) return;
                    lastIsMobile = isMobile;

                    if (!isMobile) {
                        toggleButton.style.display = 'none';
                        colList.style.display = colList.dataset.originalDisplay || 'grid';
                    } else {
                        toggleButton.style.display = 'block';
                        colList.style.display = 'none';
                        chevron.style.transform = 'rotate(-90deg)';
                    }
                };

                window.addEventListener('resize', handleResize);
                handleResize(); // initialize on load
            });
        }
    }
}

customElements.define('page-load', PageLoad);

class PerfectFitPageLoad extends HTMLElement {
    constructor() {
        super();

        this.videoContainer = this.querySelector('[data-element="page-load-container"]');
        this.video = this.querySelector('[data-element="page-load-video"]');
        this.pageGrid = this.querySelector('.page-grid');
    }

    connectedCallback() {
        const pageLoaded = sessionStorage.getItem('pageLoaded');

        if (this.video && pageLoaded !== 'true') {
            gsap.to(this.videoContainer, {
                opacity: 1,
            });

            this.video.addEventListener('ended', () => {
                this.onVideoEnd();
            }, false);
        } else {
            this.contentReveal();
        }
    }

    onVideoEnd() {
        sessionStorage.setItem('pageLoaded', 'true');
        this.contentReveal();
    }

    contentReveal() {
        const tl = gsap.timeline();

        if (this.videoContainer) {
            tl.to(this.videoContainer, {
                opacity: 0,
                onComplete: () => {
                    this.videoContainer.style.display = 'none';
                },
            });
        }

        emitter.emit('page-loaded');

        // if (this.pageGrid) {
        //     tl.to(this.pageGrid, {
        //         clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
        //     }, '>');
        // }
    }
}

customElements.define('perfect-fit-page-load', PerfectFitPageLoad);

